var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('pre',{domProps:{"innerHTML":_vm._s(JSON.stringify(this.scheda, null, 2))}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }